import { normalizeWhatsAppLinkInput } from './whatsappLink'

/** Public placeholder (10 digits) — only used when redaction is enabled */
export const WHATSAPP_NUMBER_PLACEHOLDER = '1234567891'

/**
 * Optional redaction for public screenshots / repos. By default empty — your real WhatsApp numbers are NOT replaced.
 * To enable: set in `.env`: REACT_APP_WHATSAPP_REDACT_LAST10=9380157989,8277674013 (last 10 digits only, comma-separated)
 */
const REDACT_LAST10 = new Set(
  (process.env.REACT_APP_WHATSAPP_REDACT_LAST10 || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean),
)

function last10Digits(s: string): string {
  const d = (s || '').replace(/\D/g, '')
  return d.length >= 10 ? d.slice(-10) : d
}

/** Admin form / display: digits-only field → show placeholder if number matches redacted list */
export function redactPersonalWhatsAppDigits(digitsOnly: string): string {
  const d = (digitsOnly || '').replace(/\D/g, '')
  const last10 = d.length >= 10 ? d.slice(-10) : d
  if (REDACT_LAST10.has(last10)) return WHATSAPP_NUMBER_PLACEHOLDER
  return d
}

/** E.164-style digits for wa.me / api.whatsapp.com (e.g. 91 + 10 digits) */
export function redactPersonalWhatsAppE164(e164Digits: string): string {
  const d = (e164Digits || '').replace(/\D/g, '')
  const last10 = d.length >= 10 ? d.slice(-10) : d
  if (REDACT_LAST10.has(last10)) return '91' + WHATSAPP_NUMBER_PLACEHOLDER
  if (d.length === 10) return '91' + d
  return d
}

/**
 * Admin form: full WhatsApp link — redact known personal numbers inside URL (wa.me path, phone= query).
 */
export function redactPersonalWhatsAppUrl(url: string): string {
  const u = normalizeWhatsAppLinkInput((url || '').trim())
  if (!u) return u
  if (!/^https?:\/\//i.test(u)) {
    return redactPersonalWhatsAppDigits(u)
  }
  try {
    const parsed = new URL(u)
    const phoneParam = parsed.searchParams.get('phone')
    if (phoneParam && REDACT_LAST10.has(last10Digits(phoneParam))) {
      parsed.searchParams.set('phone', '91' + WHATSAPP_NUMBER_PLACEHOLDER)
    }
    const pathRest = parsed.pathname.replace(/^\//, '')
    if (/^\d+$/.test(pathRest) && REDACT_LAST10.has(last10Digits(pathRest))) {
      parsed.pathname = '/' + '91' + WHATSAPP_NUMBER_PLACEHOLDER
    }
    return parsed.toString()
  } catch {
    let out = u
    Array.from(REDACT_LAST10).forEach((last10) => {
      out = out.split(last10).join(WHATSAPP_NUMBER_PLACEHOLDER)
    })
    return out
  }
}
